import React, { useEffect, useState } from 'react';

import { SiteConfigManager } from '@atlas/core';

import useSeoPage from 'components/SeoPage/useSeoPage';

const SeoPageText = () => {
  const seoPageContext = useSeoPage();
  const currentPageText = seoPageContext?.currentPage?.data || '';
  const [DOMPurify, installDOMPurify] = useState({});

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      installDOMPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (
    !SiteConfigManager.getConfig('config.config.seo.enable_seo_text') ||
    !currentPageText ||
    !DOMPurify.sanitize
  ) {
    return null;
  }

  return (
    <div
      className="seo-page-text"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(currentPageText, { KEEP_CONTENT: true }),
      }}
    />
  );
};

export default SeoPageText;
